<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
      <span>></span>
      小题列表
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">小题列表</div>
            <div class="xiaoqu_2">
            </div>
          </div>
          <el-button type="primary" @click="lookrule()">+ 新建小题</el-button>
          <div class="zsbg">
            <el-table :data="form" border style="width: 100%">
              <el-table-column prop="title" label="小题题干" max-width="360">
              </el-table-column>
              <el-table-column prop="level" label="难易程度">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editrule(scope.row)">编辑</el-button>
                  <el-button type="text" @click="removeTypeList(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <el-button type="primary" style="marginLeft:700px;" @click="backBigList">返回大题列表</el-button>
          <div class="fenye">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  data() {
    return {
      dialogFormVisible: false,
      newLevel: false,
      props: {
        label: 'name',
      },
      bookid_1: '',
      dianxuan: '',
      form: [],
      currentPage: 0,
      page: 1,
      pageSize: 5,
      total: 0,
      questionType: [],
      newQuestion: false,
      choosedType: '',
      questionPackId: '',
      type: '',
    };
  },
  created() {
    this.questionPackId = Number(this.$route.query.id);
    this.type = this.$route.query.type;
    this.referOrganzationList();
  },

  methods: {
    //返回大题列表
    backBigList() {
      this.$router.go(-1);
    },
    //查询小题列表
    referOrganzationList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/questions/' + this.questionPackId + '/' + this.type,
        params: {
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          console.log(res.data.data);
          res.data.data.forEach(index => {
            if(index.level<2) {
              index.level = '易';
            };
            if(index.level==2) {
              index.level = '中';
            };
            if(index.level>2) {
              index.level = '难';
            };
          });
          this.form = res.data.data;
          this.total = res.data.size;
        }
      });
    },
    //新建小题
    lookrule() {
      if (this.type == 'EXCLUSIVE') {
        this.$router.push({ path: '/single-choice', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'CHECKBOX') {
        this.$router.push({ path: '/multiple-choice', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'T_F') {
        this.$router.push({ path: '/judge', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'LISTEN_CHOICE') {
        this.$router.push({ path: '/listening-choice', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'FILL_BLANK') {
        this.$router.push({ path: '/gap-filling', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'WORD') {
        this.$router.push({ path: '/reduction-word', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'BANKED_CLOZE') {
        this.$router.push({ path: '/choose-word', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'SORT') {
        this.$router.push({ path: '/ranking-question', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'SENTENCE') {
        this.$router.push({ path: '/sentences-with-words', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'ARTICLE_FILL') {
        this.$router.push({ path: '/short-fill-in-blanks', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'READ') {
        this.$router.push({ path: '/reading-comprehension', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'INITIALS_FILL') {
        this.$router.push({ path: '/first-letter-filling', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
      if (this.type == 'CLOZE') {
        this.$router.push({ path: '/cloze-test', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number } });
      }
    },
    //编辑小题
    editrule(row) {
      if (this.type == 'EXCLUSIVE') {
        this.$router.push({ path: '/single-choice', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'CHECKBOX') {
        this.$router.push({ path: '/multiple-choice', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'T_F') {
        this.$router.push({ path: '/judge', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'LISTEN_CHOICE') {
        this.$router.push({ path: '/listening-choice', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'FILL_BLANK') {
        this.$router.push({ path: '/gap-filling', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'WORD') {
        this.$router.push({ path: '/reduction-word', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'BANKED_CLOZE') {
        this.$router.push({ path: '/choose-word', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'SORT') {
        this.$router.push({ path: '/ranking-question', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'SENTENCE') {
        this.$router.push({ path: '/sentences-with-words', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'ARTICLE_FILL') {
        this.$router.push({ path: '/short-fill-in-blanks', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'READ') {
        this.$router.push({ path: '/reading-comprehension', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'INITIALS_FILL') {
        this.$router.push({ path: '/first-letter-filling', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
      if (this.type == 'CLOZE') {
        this.$router.push({ path: '/cloze-test', query: { type: this.type, id: this.questionPackId, littleNode: this.$route.query.littleNode, bookid: this.$route.query.bookid, number: this.$route.query.number, questionId: row.questionId } });
      }
    },
    //删除小题
    removeTypeList(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise-pack/reference/' + row.id + '/' + this.questionPackId + '/' + row.questionId + '/un',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          this.referOrganzationList();
          this.$message.success('删除成功!');
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.referOrganzationList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.referOrganzationList();
    },
  },
};
</script>
<style lang="less">
.rule {
  position: relative;
  margin-top: -20px;
  .xiaoqu_1 {
    font-weight: Bold;
  }

  .xiaoqu_2 {
    position: absolute;
    font-weight: 600;
    font-size: 18px;
    top: 3px;
    right: 0;
    .icon_change {
      position: absolute;
      width: 22px;
      height: 22px;
      right: 77px;
      border-radius: 50%;
      padding: 0;
      // background: url('../../../assets/img/home/qiehuan_1.png') #00a6e6 no-repeat center;
      background-size: 0.85vw;
    }
  }
}
.clear {
  clear: both;
}
.el-pagination__editor.el-input .el-input__inner {
  width: 25px !important;
}
// .jiaocai_tu:hover {
// background: #000 !important;
// opacity: 0.6;
// }
.wjj_mc {
  .el-form-item__label {
    padding: 0 !important;
    margin-left: 5px;
  }
  .el-form-item__content {
    margin-left: 140px !important;
  }
  .wuzi {
    left: -125px !important;
  }
}
.annotation {
  margin-right: 1.875rem /* 30/16 */;
  margin-top: 10px;
  color: red;
  font-size: 14px;
}
</style>
<style>
.scroeStart {
  display: inline-block;
  width: 12.5rem /* 200/16 */;
}
.scroeEnd {
  display: inline-block;
  width: 12.5rem /* 200/16 */;
}
.hint {
  display: inline-block;
  color: #f66200;
  font-size: 0.875rem /* 14/16 */;
  margin-left: 1.25rem /* 20/16 */;
}
.el-form i {
  position: absolute;
  top: 10px;
  left: 30px;
}
.tableHeader {
  height: 0;
}
.zsbg {
  position: relative;
}

.zsbg_table2 {
  margin-top: -65px;
}
.el-card__body {
  position: relative;
}
.fenye,
.fenye-bottom_right,
.fenye-bottom_left {
  position: absolute;
  right: 10px;
  bottom: 50px;
}
</style>
